var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"main_intro"},[_c('div',{staticClass:"main_intro_inner"},[_c('div',{staticClass:"main_intro_head"},[_c('img',{attrs:{"src":_vm.iconConfirmScreenUrl,"alt":""}})]),_c('p',{staticClass:"main_intro_desc",domProps:{"innerHTML":_vm._s(_vm.$t('Checkin.this-site-uses-a-layout-designed-for-smartphones'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }